<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
.el-form-item__error{
  padding-top:0 !important
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
}
body,html{
  margin: 0;
  padding: 0;
  height: 100%;
}
.el-upload-dragger{
  height: auto !important;
}
.el-button--primary{
  background-color: #ffb329 !important;
  border-color: #ffb329 !important;
}
.title-container{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/App.vue